import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=ba99418e&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=ba99418e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba99418e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba99418e')) {
      api.createRecord('ba99418e', component.options)
    } else {
      api.reload('ba99418e', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=ba99418e&scoped=true&", function () {
      api.rerender('ba99418e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2I50zaeURC6Je/JS/teamMember.vue"
export default component.exports